<template>
<el-collapse-item name="1">
    <template v-slot:title><span style="margin-left: 20px;">Individual enhancers within Super-enhancers</span></template>
    <el-col :span="12">
        <Hubselect />
        </el-col> 
    <el-col :span="12">
        <h3 style="color:red">Function:</h3>
        <p style="font-size: large;">This module searches for <span style="color:red">individual enhancers</span> within the super-enhancer regions through species and tissue-specific samples, 
            and provides a list of individual enhancers along with their annotation information and chromosomal distribution.</p>
    </el-col> 
</el-collapse-item>
</template>

<script>
import Hubselect from '../hubAnalysis/Hubselect.vue';

export default {
    components: {
    Hubselect
},
}
</script>


// WEBPACK FOOTER //
// src/components/search/Hub.vue